/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_IncodeInputs */

const en_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Incode`)
};

const fr_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incode du projet`)
};

const de_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt Incode`)
};

const it_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto Incode`)
};

const ru_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект Incode`)
};

const es_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto Incode`)
};

const zh_cn2_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目编码`)
};

const ja_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト・インコード`)
};

const hi_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट इनकोड`)
};

const pt_pt2_project_incode = /** @type {(inputs: Project_IncodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto Incode`)
};

/**
* | output |
* | --- |
* | "Project Incode" |
*
* @param {Project_IncodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_incode = /** @type {((inputs?: Project_IncodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_IncodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_incode(inputs)
	if (locale === "de") return de_project_incode(inputs)
	if (locale === "it") return it_project_incode(inputs)
	if (locale === "ru") return ru_project_incode(inputs)
	if (locale === "es") return es_project_incode(inputs)
	if (locale === "zh-CN") return zh_cn2_project_incode(inputs)
	if (locale === "ja") return ja_project_incode(inputs)
	if (locale === "hi") return hi_project_incode(inputs)
	if (locale === "pt-PT") return pt_pt2_project_incode(inputs)
	return en_project_incode(inputs)
});